export default {
  navMenuList: [
    {
      id: 'private',
      title: 'Private',
      subYn: true,
      path: '',
      subList: [{ id: 'private', title: 'My meetings', subYn: false, path: '/meeting/private', icon: 'mdi-account' }],
    },
    {
      id: 'workspace',
      title: 'Workspace',
      subYn: true,
      path: '',
      subList: [
        { id: 'workspace', title: 'General', subYn: false, path: '/meeting/workspace', icon: 'mdi-account-multiple' },
      ],
    },
  ],
  /**
   * VideoJS Subtitle 관련 국가 코드
   */
  language: [
    { code: 'en', country: 'English' },
    { code: 'ko', country: 'Korean' },
    { code: 'ab', country: 'Abkhazian' },
    { code: 'aa', country: 'Afar' },
    { code: 'af', country: 'Afrikaans' },
    { code: 'sq', country: 'Albanian' },
    { code: 'am', country: 'Amharic' },
    { code: 'ar', country: 'Arabic' },
    { code: 'an', country: 'Aragonese' },
    { code: 'hy', country: 'Armenian' },
    { code: 'as', country: 'Assamese' },
    { code: 'ay', country: 'Aymara' },
    { code: 'az', country: 'Azerbaijani' },
    { code: 'ba', country: 'Bashkir' },
    { code: 'eu', country: 'Basque' },
    { code: 'bn', country: 'Bengali (Bangla)' },
    { code: 'dz', country: 'Bhutani' },
    { code: 'bh', country: 'Bihari' },
    { code: 'bi', country: 'Bislama' },
    { code: 'br', country: 'Breton' },
    { code: 'bg', country: 'Bulgarian' },
    { code: 'my', country: 'Burmese' },
    { code: 'be', country: 'Byelorussian (Belarusian)' },
    { code: 'km', country: 'Cambodian' },
    { code: 'ca', country: 'Catalan' },
    { code: 'zh', country: 'Chinese (Simplified)' },
    { code: 'zh', country: 'Chinese (Traditional)' },
    { code: 'co', country: 'Corsican' },
    { code: 'hr', country: 'Croatian' },
    { code: 'cs', country: 'Czech' },
    { code: 'da', country: 'Danish' },
    { code: 'nl', country: 'Dutch' },
    { code: 'eo', country: 'Esperanto' },
    { code: 'et', country: 'Estonian' },
    { code: 'fo', country: 'Faeroese' },
    { code: 'fa', country: 'Farsi' },
    { code: 'fj', country: 'Fiji' },
    { code: 'fi', country: 'Finnish' },
    { code: 'fr', country: 'French' },
    { code: 'fy', country: 'Frisian' },
    { code: 'gl', country: 'Galician' },
    { code: 'gd', country: 'Gaelic (Scottish)' },
    { code: 'gv', country: 'Gaelic (Manx)' },
    { code: 'ka', country: 'Georgian' },
    { code: 'de', country: 'German' },
    { code: 'el', country: 'Greek' },
    { code: 'kl', country: 'Greenlandic' },
    { code: 'gn', country: 'Guarani' },
    { code: 'gu', country: 'Gujarati' },
    { code: 'ht', country: 'Haitian Creole' },
    { code: 'ha', country: 'Hausa' },
    { code: 'he', country: 'Hebrew' },
    { code: 'hi', country: 'Hindi' },
    { code: 'hu', country: 'Hungarian' },
    { code: 'is', country: 'Icelandic' },
    { code: 'io', country: 'Ido' },
    { code: 'id', country: 'Indonesian' },
    { code: 'ia', country: 'Interlingua' },
    { code: 'ie', country: 'Interlingue' },
    { code: 'iu', country: 'Inuktitut' },
    { code: 'ik', country: 'Inupiak' },
    { code: 'ga', country: 'Irish' },
    { code: 'it', country: 'Italian' },
    { code: 'ja', country: 'Japanese' },
    { code: 'jv', country: 'Javanese' },
    { code: 'kn', country: 'Kannada' },
    { code: 'ks', country: 'Kashmiri' },
    { code: 'kk', country: 'Kazakh' },
    { code: 'rw', country: 'Kinyarwanda (Ruanda)' },
    { code: 'ky', country: 'Kirghiz' },
    { code: 'rn', country: 'Kirundi (Rundi)' },
    { code: 'ku', country: 'Kurdish' },
    { code: 'lo', country: 'Laothian' },
    { code: 'la', country: 'Latin' },
    { code: 'lv', country: 'Latvian (Lettish)' },
    { code: 'li', country: 'Limburgish ( Limburger)' },
    { code: 'ln', country: 'Lingala' },
    { code: 'lt', country: 'Lithuanian' },
    { code: 'mk', country: 'Macedonian' },
    { code: 'mg', country: 'Malagasy' },
    { code: 'ms', country: 'Malay' },
    { code: 'ml', country: 'Malayalam' },
    { code: 'mt', country: 'Maltese' },
    { code: 'mi', country: 'Maori' },
    { code: 'mr', country: 'Marathi' },
    { code: 'mo', country: 'Moldavian' },
    { code: 'mn', country: 'Mongolian' },
    { code: 'na', country: 'Nauru' },
    { code: 'ne', country: 'Nepali' },
    { code: 'no', country: 'Norwegian' },
    { code: 'oc', country: 'Occitan' },
    { code: 'or', country: 'Oriya' },
    { code: 'om', country: 'Oromo (Afan, Galla)' },
    { code: 'ps', country: 'Pashto (Pushto)' },
    { code: 'pl', country: 'Polish' },
    { code: 'pt', country: 'Portuguese' },
    { code: 'pa', country: 'Punjabi' },
    { code: 'qu', country: 'Quechua' },
    { code: 'rm', country: 'Rhaeto-Romance' },
    { code: 'ro', country: 'Romanian' },
    { code: 'ru', country: 'Russian' },
    { code: 'sm', country: 'Samoan' },
    { code: 'sg', country: 'Sangro' },
    { code: 'sa', country: 'Sanskrit' },
    { code: 'sr', country: 'Serbian' },
    { code: 'sh', country: 'Serbo-Croatian' },
    { code: 'st', country: 'Sesotho' },
    { code: 'tn', country: 'Setswana' },
    { code: 'sn', country: 'Shona' },
    { code: 'ii', country: 'Sichuan Yi' },
    { code: 'sd', country: 'Sindhi' },
    { code: 'si', country: 'Sinhalese' },
    { code: 'ss', country: 'Siswati' },
    { code: 'sk', country: 'Slovak' },
    { code: 'sl', country: 'Slovenian' },
    { code: 'so', country: 'Somali' },
    { code: 'es', country: 'Spanish' },
    { code: 'su', country: 'Sundanese' },
    { code: 'sw', country: 'Swahili (Kiswahili)' },
    { code: 'sv', country: 'Swedish' },
    { code: 'tl', country: 'Tagalog' },
    { code: 'tg', country: 'Tajik' },
    { code: 'ta', country: 'Tamil' },
    { code: 'tt', country: 'Tatar' },
    { code: 'te', country: 'Telugu' },
    { code: 'th', country: 'Thai' },
    { code: 'bo', country: 'Tibetan' },
    { code: 'ti', country: 'Tigrinya' },
    { code: 'to', country: 'Tonga' },
    { code: 'ts', country: 'Tsonga' },
    { code: 'tr', country: 'Turkish' },
    { code: 'tk', country: 'Turkmen' },
    { code: 'tw', country: 'Twi' },
    { code: 'ug', country: 'Uighur' },
    { code: 'uk', country: 'Ukrainian' },
    { code: 'ur', country: 'Urdu' },
    { code: 'uz', country: 'Uzbek' },
    { code: 'vi', country: 'Vietcountryse' },
    { code: 'vo', country: 'Volapük' },
    { code: 'wa', country: 'Wallon' },
    { code: 'cy', country: 'Welsh' },
    { code: 'wo', country: 'Wolof' },
    { code: 'xh', country: 'Xhosa' },
    { code: 'yi', country: 'Yiddish' },
    { code: 'yo', country: 'Yoruba' },
    { code: 'zu', country: 'Zulu' },
  ],
  defaultTemplate: [
    {
      type: 'designReview',
      mtTitle: 'Design Review',
      clipInfos: [
        {
          clipTitle: 'Design Review',
          clipNote:
            'Share your design work with clarity using 📼 video.\nAsk for feedback using on-video comments or video replies.',
          clipType: 'followUp',
        },
        {
          clipTitle: 'Feedback',
          clipNote:
            'Ask feedback from the stakeholders. Allow them to take time to think, research, and provide well-considered responses.',
          clipType: 'followUp',
        },
      ],
    },
    {
      type: 'bugReport',
      mtTitle: 'New Issue',
      clipInfos: [
        {
          clipTitle: 'Bug Description',
          clipNote:
            'Show what the issue is, and how to reproduce it with clarity.\nAlso, show how the app is supposed to work.',
          clipType: 'followUp',
        },
        {
          clipTitle: 'Bug Fix Demo',
          clipNote: 'Ask for a demo when the issue has been fixed.',
          clipType: 'followUp',
        },
      ],
    },
    {
      type: 'meetingPreWatch',
      mtTitle: 'Meeting Pre-watch',
      clipInfos: [
        {
          clipTitle: 'Pre-watch',
          clipNote:
            'A pre-watch video can help to make your meeting more efficient and productive.\nShare background information and any relevant materials that will be discussed during the meeting.',
          clipType: 'followUp',
        },
        {
          clipTitle: 'Meeting Recording',
          clipNote:
            'Upload meeting recording when the meeting is over for people who were unable to attend the meeting',
          clipType: 'followUp',
        },
      ],
    },
    {
      type: 'projectSpecs',
      mtTitle: 'Project Specs',
      clipInfos: [
        {
          clipTitle: 'Overview - Problem & Proposed work',
          clipNote: `Documents are useful, but often they are not clear enough. Share project specs with clarity using 📼 video. Describe the problem we're trying to solve by doing the work and high-level overview of what we're building and why we think it'll solve the problem.`,
          clipType: 'followUp',
        },
        {
          clipTitle: 'Dependencies & risks',
          clipNote:
            'Describe who the stakeholders are, what the risks are, and the dependencies including both internal and external.',
          clipType: 'followUp',
        },
        {
          clipTitle: 'Success criteria',
          clipNote: 'Describe the criteria that must be met to consider this project a success.',
          clipType: 'followUp',
        },
        {
          clipTitle: 'Project Demo',
          clipNote: 'Show a demo when this project has been done and celebrate 👏',
          clipType: 'followUp',
        },
      ],
    },
    // {
    //   type: 'polls',
    //   clipInfos: [
    //     {
    //       clipType: 'poll',
    //       contentData: {
    //         type: 'poll',
    //         pollQuestion: 'This is poll title',
    //         pollChoices: [
    //           { title: 'Example 1 😀', voterList: [] },
    //           { title: 'Example 2 🙇🏻‍♂️', voterList: [] },
    //         ],
    //       },
    //     },
    //   ],
    // },
  ],
}
